import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgileComponent } from './agile/agile.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, AgileComponent],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
